window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');
// console.log(process.env.MIX_PUSHER_APP_KEY);
// window.Echo = new Echo({
    // broadcaster: 'pusher',
    // key: process.env.MIX_PUSHER_APP_KEY,
    // cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    // forceTLS: false,
    // wsHost: window.location.hostname,
    // wsPort: 6002,
    // enabledTransports: ['ws', 'wss']


    // broadcaster: 'pusher',
    // key: '3a74056a880e42142d54',
    // cluster: 'ap2',
    // forceTLS: false,
    // wsHost: window.location.hostname,
    // wsPort: 6001,
    // enabledTransports: ['ws', 'wss']
// });


// console.log(6001);

if (process.client) {
    window.io = require('socket.io-client')
}
window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: window.location.hostname + ":" + 6001
});
